import { z } from 'zod/v3';
import { zValidPeriod } from '../../common/utils';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import {
  CalculationErrorSchema,
  MissingSourceDataErrorSchema,
} from '../../processingEvent/schema/OutputProcessingEventDetailsSchema';

export const OutputTestCalculationDetailsSchema = z.object({
  versionId: z.number(),
  code: z.string(),
  name: z.string(),
  statusCode: z.string(),
  versionNumber: z.number(),
  validPeriod: zValidPeriod(),
  algorithmCodes: z.array(z.string()),
  valueDate: z.string(),
  sourceDataVersionId: z.number(),
  dagRunId: z.string(),
  queueTime: zIsoDateTime(),
});

export const OutputTestCalculationSchema = z.object({
  processingEventId: z.number(),
  startTime: zIsoDateTime().nullable(),
  endTime: zIsoDateTime().nullable(),
  calculationErrors: CalculationErrorSchema.array(),
  missingSourceDataErrors: MissingSourceDataErrorSchema.array(),
});
